import {
  ADD_LIST,
  REMOVE_LIST,
  SET_LIST_CHECKED,
  SET_LISTS,
} from "../../constants/reducerEvents";
import { addList, deleteList } from "../../endpoints/endpoints";

const INITIAL_STATE = [];
export default function listsReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case SET_LISTS:
      return action.payload;
    case ADD_LIST:
      addList(action.payload);
      if (state.some((l) => l.id === action.payload.id)) {
        return state.map((l) =>
          l.id === action.payload.id ? action.payload : l
        );
      }
      return [...state, action.payload];
    case REMOVE_LIST:
      deleteList(action.payload);
      return state.filter((l) => l.id !== action.payload);
    case SET_LIST_CHECKED:
      return state.map((l) => {
        if (l.id === action.payload.id) {
          const newList = {
            ...l,
            checked: action.payload.checked,
          };
          addList(newList);
          return newList;
        }
        return l;
      });
    default:
      return state;
  }
}
